

/*
  Projects To Display
  - Analytica
  - ParkVue
  - Vet4Hire
  - School Management System
  - Read Log
  -----------------
  Each Project Details 
  > Project Name
  > Oneline Description
  > Project Discription
  > Technologies And Languages
  > Team Memebers
  > catogory :[small, mediam, large]
  > Background Image
*/
// 
const projects = [
    {
        name: "Analytica",
        linerDescription: "Take charge of your mobile game's unparalleled success with our data analyzer, empowering decisions on monetization, engagement, and stability through Playstore insights.",
        fullDescription: "",
        technologies: {
            frontend: {
                name: "React",
                expertise: 40,
                language: ["Javascript"],
            },
            backend: {
                name: "Express",
                expertise: 50,
                language: ["Node"],
            },
            database: {
                name: "Mongo",
                expertise: 60,
                language: ["query"],
            }
        },
        teamMembers: [
            {
                name: "Muhammad Afnan Akram",
                linkedin: ""
            },
            {
                name: "Sumama Shakeel",
                linkedin: "",
            }
        ],
        backgroundImage: "",
        catagory: "mediam"
    }
    ,
    {
        name: "BookPrev",
        linerDescription: "Discover and track books with ease using our web-based platform, offering search by categories, authors, book summary and personalized reading habit monitoring",
        fullDescription: "",
        technologies: {
            frontend: {
                name: "React",
                expertise: 40,
                language: ["Java"],
            },
            backend: {
                name: "Spring Boot",
                expertise: 50,
                language: ["Java"],
            },
            database: {
                name: "Cassandra",
                expertise: 60,
                language: ["CSQL"],
            }
        },
        teamMembers: [
        ],
        backgroundImage: "",
        catagory: "mediam"
    },
    {
        name: "ParkVue",
        linerDescription: "The Smart Parking System is powered by image processing, offering live feeds, real-time updates, and effortless spot requests, ensuring a seamless parking experience.",
        fullDescription: "",
        technologies: {
            frontend: {
                name: "Jinja",
                expertise: 30,
                language: ["HTML"],
            },
            backend: {
                name: "Flask",
                expertise: 50,
                language: ["Python"],
            },
            database: {
                name: "SQL Lite",
                expertise: 60,
                language: ["SQL"]
            }

        },
        teamMembers: [
            {
                name: "Afnan Akram",
                linkedin: ""
            },
            {
                name: "Sumama Shakeel",
                linkedin: "",
            }
        ]
        ,
        catagory: "mediam",
        backgroundImage: "",
    },
    {
        name: "Vet4Hire",
        linerDescription: "Veteran-focused social media app connecting experienced veterans with youth, enabling NGOs to hire them for inspirational talks, with profile-building and badges.",
        fullDescription: "",
        technologies: {
            frontend: {
                name: "React",
                expertise: 70,
                language: ["JavaScript","Scss"],
            },
            backend: {
                name: "Express",
                expertise: 70,
                language: ["Node","JavaScript"],
            },
            database: {
                name: "MongoDB",
                expertise: 60,
                language: ["Mongo"]
            }
        },
        teamMembers: [
            {
                name: "Muhammad Saad",
                linkedin: ""
            },
            {
                name: "Muhammad Ahsan",
                linkedin: "",
            }
        ],
        backgroundImage: "",
        catagory: "mediam"
    },
    {
        name: "Shopping Website",
        linerDescription: "Innovative web plateform, ShopEase, redefines shopping with seamless and interactive user experience and the Fake Store API for a captivating online destination.",
        fullDescription: "",
        technologies: {
            frontend: {
                name: "React",
                expertise: 70,
                language: ["JavaScript","Scss"],
            },
            backend: {
                name: "Express",
                expertise: 70,
                language: ["Node","JavaScript"],
            },
            database: {
                name: "MongoDB",
                expertise: 60,
                language: ["Mongo"]
            }
        },
        teamMembers: [
            {
                name: "Muhammad Saad",
                linkedin: ""
            },
            {
                name: "Muhammad Ahsan",
                linkedin: "",
            }
        ],
        backgroundImage: "",
        catagory: "mediam"
    },
    {
        name: "School Management System",
        linerDescription: "School management system with for school related processes i.e. student profile management, attendance tracking, and timetable organization for efficient school administration.",
        fullDescription: "",
        technologies: {
            frontend: {
                name: "JavaFx",
                expertise: 40,
                language: ["Java"],
            },
            backend: {
                name: "Java Core",
                expertise: 50,
                language: ["Java"],
            },
            database: {
                name: "MySQL",
                expertise: 60,
                language: ["SQL"],
            }
        },
        teamMembers: [
            {
                name: "Muhammad Afnan Akram",
                linkedin: ""
            },
            {
                name: "Sumama Shakeel",
                linkedin: "",
            }
        ],
        backgroundImage: "",
        catagory: "mediam"
    }

]

export default projects;



/*

,
*/